import { gql } from "@apollo/client";

export const NOTIFICATIONS_QUERY = gql`
    query Notifications(
        $unreadOnly: Boolean
        $notificationType: String
        $limit: Int
    ) {
        notifications(
            unreadOnly: $unreadOnly
            notificationType: $notificationType
            limit: $limit
        ) {
            id
            notificationType
            title
            message
            isRead
            createdAt
            readAt
            actionUrl
            imageUrl
            relatedObjectId
            relatedObjectType
            sender {
                id
                twitchUsername
            }
            isBroadcast
            isGroupMessage
        }
        notificationCount {
            total
            unread
        }
    }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
    mutation MarkNotificationAsRead($notificationId: UUID!) {
        markNotificationAsRead(notificationId: $notificationId) {
            success
            notification {
                id
                isRead
                readAt
            }
        }
    }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
    mutation MarkAllNotificationsAsRead {
        markAllNotificationsAsRead {
            success
            count
        }
    }
`;

export const DELETE_NOTIFICATION = gql`
    mutation DeleteNotification($notificationId: UUID!) {
        deleteNotification(notificationId: $notificationId) {
            success
        }
    }
`;

export const NOTIFICATION_SUBSCRIPTION = gql`
    subscription NotificationReceived {
        notificationReceived {
            id
            notificationType
            title
            message
            isRead
            createdAt
            readAt
            actionUrl
            imageUrl
            relatedObjectId
            relatedObjectType
            sender {
                id
                twitchUsername
            }
            isBroadcast
            isGroupMessage
        }
    }
`;
